export default __webpack_public_path__ + "static/media/DFD.9bb62fe8.png";